(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Gestion des remarques d'accessibilité globales
 */
var Accessibility =
/*#__PURE__*/
function () {
  /**
   *
   */
  function Accessibility() {
    _classCallCheck(this, Accessibility);

    this.ll = {
      newWindow: GBIS.lang === 'fr' ? 'Ouvrir dans une nouvelle fenêtre' : 'Open in a new window'
    };
    this.targetBlankPdfLinks();
    this.tweakAria();
  }

  _createClass(Accessibility, [{
    key: "tweakAria",
    value: function tweakAria() {
      // gestion spécifiqe pour les listes, beaucoup plus de simple de le faire ne js
      var listItems = document.querySelectorAll('.wallCardRow_card, .wallInsights__item');
      listItems.forEach(function (elt) {
        elt.setAttribute('role', 'listitem');
        var parent = elt.closest('.wallCardItems, .wallInsights');

        if (parent) {
          parent.setAttribute('role', 'list');
        }
      });
    }
    /**
     * Gestion des lien PDF
     * Permet de forcer l'ouverture des liens PDF dans un nouvel onglet
     */

  }, {
    key: "targetBlankPdfLinks",
    value: function targetBlankPdfLinks() {
      var _this = this;

      var linksPdf = document.querySelectorAll('a[href$=".pdf"]');
      linksPdf.forEach(function (elt) {
        // petit target blank, ca mange pas de pain pour le pdf
        elt.setAttribute('target', '_blank'); // on va ajouter un arial label s'il en existe pas

        if (!elt.getAttribute('aria-label')) {
          // on recupère le texte du lien sans le html
          var text = elt.textContent || elt.innerText;
          elt.setAttribute('aria-label', text + ', PDF, ' + _this.ll.newWindow);
        }
      });
    }
  }]);

  return Accessibility;
}();

module.exports = Accessibility;

},{}],2:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Gestion des ancre au seins du site
 *  Le but est de courcircuiter le système d'ancre par defaut
 * on regroupe tout ici
 */
var Anchors =
/*#__PURE__*/
function () {
  /**
   *
   */
  function Anchors() {
    var _this = this;

    _classCallCheck(this, Anchors);

    //console.debug('Anchors : Construct');
    var _self = this;

    window.onhashchange = function () {
      _self.scrollToAnchor(window.location.hash);
    };

    if (window.location.hash) {
      this.scrollToAnchor(window.location.hash);
    }

    $(document).ready(function () {
      var hash = document.location.hash;

      if (hash) {
        _this.scrollToAnchor(hash);
      }
    }); // gestion du lient sur le header FULL Height

    $('.headerScrollBottom').on('click', function () {
      _this.scrollHeaderFH();
    });
  }
  /**
   * Permet de scroller toute la partie haute d'un site (pour le design PB2019 avec le header hull Heeight)
   */


  _createClass(Anchors, [{
    key: "scrollHeaderFH",
    value: function scrollHeaderFH() {
      var offsetToScroll = $('.contentHeaderFH').height();

      if ($('.headerProducts').length) {
        offsetToScroll = $('.headerProducts').height();
      }

      $('html, body').stop().animate({
        scrollTop: offsetToScroll
      }, 1000);
    }
  }, {
    key: "scrollToAnchor",
    value: function scrollToAnchor(anchor) {
      //console.debug('Anchors : scrollToAnchor', anchor);
      var $fixedheader = $('.fixedheader.active');
      var $itemTogo = $('[data-anchor="' + anchor + '"]');

      if ($itemTogo.length) {
        var speed = 750;
        var offSet = gbis.isOnePageMenu ? 100 : 150;

        if ($fixedheader.length) {
          offSet += $fixedheader.height();
        } //console.debug('Anchors : scrolto : ', $itemTogo.offset().top - offSet);


        $('html, body').stop().animate({
          scrollTop: $itemTogo.offset().top - offSet
        }, speed);
      }
    }
  }]);

  return Anchors;
}();

module.exports = Anchors;

},{}],3:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 */
var ContactFormOverlay =
/*#__PURE__*/
function () {
  /**
   *
   */
  function ContactFormOverlay() {
    _classCallCheck(this, ContactFormOverlay);

    console.debug('ContactFormOverlay : Construct');

    if ($('.contactFormOverlay').length) {
      this.init();
    }
  }

  _createClass(ContactFormOverlay, [{
    key: "init",
    value: function init() {
      var _this = this;

      this.isLogoWhite = $('body').hasClass('logoWhite');
      $('.mainMenuOneLine--contact, .shareBtn__row__btn--contact').on('click', function () {
        _this.open();

        return false;
      });
      $('.contactFormOverlay__close').on('click', function () {
        _this.close();
      });

      if (document.location.href.indexOf('tx_powermail_pi1') >= 0) {
        this.open();
      }
    }
  }, {
    key: "open",
    value: function open() {
      $('body').addClass('noscroll');
      if (!this.isLogoWhite) $('body').addClass('logoWhite');
      TweenMax.set('.contactFormOverlay', {
        display: 'block'
      });
      $('.contactFormOverlay__right .h2').SGMovingLine();

      if (isMobile()) {
        TweenMax.to('.contactFormOverlay', 0.5, {
          xPercent: 100,
          ease: Expo.easeInOut
        });
      } else {
        TweenMax.to('.contactFormOverlay__left', 0.5, {
          yPercent: 100,
          ease: Expo.easeInOut
        });
        TweenMax.to('.contactFormOverlay__right', 0.5, {
          yPercent: -100,
          ease: Expo.easeInOut
        });
      }
    }
  }, {
    key: "close",
    value: function close() {
      $('body').removeClass('noscroll');
      if (!this.isLogoWhite) $('body').removeClass('logoWhite');

      if (isMobile()) {
        TweenMax.to('.contactFormOverlay', 0.5, {
          xPercent: 0,
          ease: Expo.easeInOut,
          onComplete: function onComplete() {
            TweenMax.set('.contactFormOverlay', {
              display: 'none'
            });
          }
        });
      } else {
        TweenMax.to('.contactFormOverlay__left', 0.5, {
          yPercent: 0,
          ease: Expo.easeInOut
        });
        TweenMax.to('.contactFormOverlay__right', 0.5, {
          yPercent: 0,
          ease: Expo.easeInOut,
          onComplete: function onComplete() {
            TweenMax.set('.contactFormOverlay', {
              display: 'none'
            });
          }
        });
      }
    }
  }]);

  return ContactFormOverlay;
}();

module.exports = ContactFormOverlay;

},{}],4:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Debug =
/**
 *
 */
function Debug() {
  _classCallCheck(this, Debug);

  console.debug('Debug : Construct');
  $('.debugBar__moreBtn').on('click', function () {
    $('.debugBar__more').slideToggle();
  });
  $('.debugBar__cat').on('click', function () {
    $(this).next('.debugBar__content').slideToggle();
  });
};

module.exports = Debug;

},{}],5:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Gestion du JS lié au plugin headerModule (typo3conf/ext/bi_template/plugins/headerProducts/class.tx_bitemplate_piheaderproducts.php)
 */
var HeaderProducts =
/*#__PURE__*/
function () {
  /**
   * Simple constructeur, qui vérifie la présence du bloc
   */
  function HeaderProducts() {
    _classCallCheck(this, HeaderProducts);

    console.debug('HeaderProducts : Construct');

    if ($('.headerProducts').length) {
      this.init();
    }
  }
  /**
   * Initialise tout les handler, et définir les containers
   */


  _createClass(HeaderProducts, [{
    key: "init",
    value: function init() {
      var _this = this;

      console.debug('HeaderProducts : init');

      var _self = this;

      this.$header = $('.headerProducts');
      this.$select = $('.headerProducts__select');
      this.$label = $('.headerProducts__select__label');
      this.$choices = $('.headerProducts__select__choices');
      this.$choicesItem = $('.headerProducts__select__choices__item');
      this.$choicesItemLast = $('.headerProducts__select__choices__item:last-child');
      this.$bgs = $('.headerProducts__backgrounds__item');
      this.$btnGo = $('.headerProducts__select__projects__item a');
      this.initLabel = this.$label.html();
      this.$header.on('click', function () {
        _this.closeChoices();
      });
      $('.headerProducts__select__label').on('click', function (e) {
        e.stopPropagation();

        _this.openChoices();
      });
      this.$choicesItem.on('click', function () {
        _self.selectChoice($(this).data('uid'));
      });
      this.$choicesItemLast.on('blur', function () {
        _self.closeChoices();
      });
      this.selectBg();
    }
    /**
     * Affiche un background aléatoire, obbligé de le faire en JS a cause du CDN
     */

  }, {
    key: "selectBg",
    value: function selectBg() {
      console.debug('HeaderProducts : selectBg'); // on affiche un choix aléatoire

      console.debug(this.$bgs);
      var random = Math.floor(Math.random() * Math.floor(this.$bgs.length));
      var myBg = this.$bgs.eq(random);
      myBg.show(); // on va changer la couleur du header en fonction

      changeHeaderLogo(myBg.data('headercolor')); // on va changer le couleur du contenu en fonctin

      this.$header.addClass('headerProducts--' + myBg.data('contentcolor'));
    }
    /**
     * action quand on click sur un des choix de la tooltip
     */

  }, {
    key: "selectChoice",
    value: function selectChoice(id) {
      console.debug('HeaderProducts : selectChoice', id); // on masque tous les choix

      $('.headerProducts__select__projects__item').hide(); // on affiche le choix selectionné

      $('.headerProducts__select__projects__item[data-uid=' + id + ']').show(); // on change le label pour voir la valeur selectionné

      this.$label.html($('.headerProducts__select__choices__item[data-uid=' + id + ']').html()); // on ajuste le arial-label du bouton go

      this.$btnGo.attr('aria-label', this.$btnGo.data('label') + '     ' + $('.headerProducts__select__choices__item[data-uid=' + id + ']').html());
      this.closeChoices();
    }
    /**
     * Ouvre la tooltip des choix
     */

  }, {
    key: "openChoices",
    value: function openChoices() {
      console.debug('HeaderProducts : openChoices');
      this.$select.attr('aria-expanded', 'true');
      TweenMax.set(this.$choices, {
        display: 'block',
        alpha: 0
      });
      TweenMax.fromTo(this.$choices, 0.5, {
        alpha: 0,
        y: 10
      }, {
        alpha: 1,
        y: 0
      });
    }
    /**
     * ferme la tooltip des choix
     */

  }, {
    key: "closeChoices",
    value: function closeChoices() {
      var _this2 = this;

      var _self = this;

      this.$select.attr('aria-expanded', 'false');
      TweenMax.to(this.$choices, 0.5, {
        alpha: 0,
        y: 10,
        onComplete: function onComplete() {
          _this2.$choices.hide();
        }
      });
    }
  }]);

  return HeaderProducts;
}();

module.exports = HeaderProducts;

},{}],6:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ImgCopyright =
/*#__PURE__*/
function () {
  /**
   *
   */
  function ImgCopyright() {
    var _this = this;

    _classCallCheck(this, ImgCopyright);

    // console.debug('imgCopyRight : Construct');
    this.$img = $('.bodytext img');

    if (this.$img.length) {
      this.$img.each(function (index, elt) {
        _this.buildMarkup($(elt));
      });
    }
  }

  _createClass(ImgCopyright, [{
    key: "buildMarkup",
    value: function buildMarkup($imgElt) {
      // console.debug($imgElt);
      if ($imgElt.attr('title') !== undefined) {
        // gestion du markup de base
        $imgElt.wrap('<div class="rteimg"></div>');
        var title = $imgElt.attr('title');
        var $div = $('<div class="rteimg__copyright"></div>');
        $div.html(title);
        $imgElt.after($div); // si l'image à un style float on reporte le style sur le parent

        if ($imgElt.css('float') !== 'none') {
          $imgElt.parent().css('float', $imgElt.css('float'));
          $imgElt.css('float', 'none');
        }
      }
    }
  }]);

  return ImgCopyright;
}();

module.exports = ImgCopyright;

},{}],7:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// on récupère juste les bout de code fait dans les DCE par slumberlan pour les centraliser ici
// pas de refacto profonde pour éviter les effet de bords
var KeyFigure = function KeyFigure() {
  _classCallCheck(this, KeyFigure);

  // gestion du commpteur
  $('.keyfigure .count').each(function () {
    $(this).onScreen({
      container: window,
      direction: 'vertical',
      doIn: function doIn() {
        if (!$(this).hasClass("animated")) {
          $(this).prop('Counter', 0).animate({
            Counter: $(this).text()
          }, {
            duration: 4000,
            easing: 'swing',
            step: function step(now) {
              $(this).text(Math.ceil(now));
            }
          });
        }

        $(this).addClass("animated");
      },
      doOut: function doOut() {}
    });
  }); // cas particulier inconu

  $(".colored .keyfigure").each(function () {
    var $containerColored = $(this).closest(".ttcContent");
    $containerColored.addClass('--nopadding');
  });
};

module.exports = KeyFigure;

},{}],8:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Petit objet permettant de construire le menu quand on active le one page mode
 * le principe est le suivant, on récupère toutes les sections 100% qui n'ont pas la class nomenu dans le backend
 * on constuire ensuite automatiquement le menu (on part sur du full JS)
 */
require('./accessibility');

var OnePageModeMenu =
/*#__PURE__*/
function () {
  /**
   *
   */
  function OnePageModeMenu() {
    _classCallCheck(this, OnePageModeMenu);

    console.debug('OnePageModeMenu : Construct');
    this.ll = {
      scrollTo: GBIS.lang === 'fr' ? 'Scroller à la section' : 'Scroll to section'
    };
    this.init();
  }
  /**
   *
   */


  _createClass(OnePageModeMenu, [{
    key: "init",
    value: function init() {
      console.debug('OnePageModeMenu : init');
      this.$container = $('.onePageMenu--automatic');
      if (this.$container.length === 0) return;
      this.getSections();
      this.build();
      this.$container.scrollToFixed({
        spacerClass: 'spacerClass'
      });
    }
    /**
     * Recupère les section en fonction du markup js
     */

  }, {
    key: "getSections",
    value: function getSections() {
      this.sections = [];

      var _self = this;

      $('.grid100').each(function (elt) {
        if ($(this).parents('.nomenu').length === 0) {
          var myTitle = $(this).prev().html();

          if (GBIS.frontend_editing) {
            myTitle = $(this).prev().deepest().html();
          }

          if (myTitle !== undefined) {
            myTitle = myTitle.trim();

            if (myTitle !== '') {
              _self.sections.push({
                'title': myTitle,
                'elt': $(this),
                'link': document.location.origin + document.location.pathname + '#' + $(this).parent('.frame').attr('id')
              });
            }
          }
        } //$(this).prev().SGMovingLine().addClass('mlTitle--center h1');


        $(this).prev().addClass('ce-headline-center');
      });
    }
  }, {
    key: "build",
    value: function build() {
      var _this = this;

      if (this.sections) {
        this.sections.forEach(function (section) {
          var item = $('<a>', {
            "class": "onePageMenu__item",
            href: section.link,
            html: $('<span>', {
              text: section.title
            }),
            'aria-label': _this.ll.scrollTo + ' ' + section.title
          });
          $(item).on('click', function (event) {
            var firstChild = section.elt.find('a[href], button, input, select, textarea');

            if (firstChild) {
              firstChild[0].focus();
            }

            event.preventDefault();
            $('html, body').stop().animate({
              scrollTop: section.elt.prev().offset().top - 100
            }, 1000);
          });

          _this.$container.append(item);
        });
      }
    }
  }]);

  return OnePageModeMenu;
}();

module.exports = OnePageModeMenu;

},{"./accessibility":1}],9:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 */
var ScrollAnimations =
/*#__PURE__*/
function () {
  /**
   *
   */
  function ScrollAnimations() {
    _classCallCheck(this, ScrollAnimations);

    console.debug('ScrollAnimations : Construct');
    this.controller = new ScrollMagic.Controller();
    this.$selfAnimated = $('.ttcContent_selfAnimated');
    this.$childrenAnimated = $('.ttcContent_childrenAnimated');

    var _self = this; // Gestion des animatins sur le bloc en lui même


    if (this.$selfAnimated.length) {
      this.$selfAnimated.each(function () {
        _self.applyScene(this);
      });
    }

    if (this.$childrenAnimated.length) {
      this.$childrenAnimated.each(function () {
        _self.applyScene(this);
      });
    }
  }
  /**
   *
   * @param elt
   */


  _createClass(ScrollAnimations, [{
    key: "applyScene",
    value: function applyScene(elt) {
      var trigger = $(elt).prev().get(0);
      $(elt).addClass('ttcContent_animated');
      new ScrollMagic.Scene({
        triggerElement: trigger,
        triggerHook: 0.85,
        // show, when scrolled 10% into view
        duration: "300%",
        // hide 10% before exiting view (80% + 10% from bottom)
        offset: 50 // move trigger to center of element

      }).setClassToggle(elt, "ttcContent_visible") // add class to reveal
      //.addIndicators() // add indicators (requires plugin)
      .addTo(this.controller);
    }
  }]);

  return ScrollAnimations;
}();

module.exports = ScrollAnimations;

},{}],10:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Petit objet permettant de construire le menu vertical permettant de passer de H2 en H2
 */
var VerticalAnchorMenu =
/*#__PURE__*/
function () {
  /**
   *
   */
  function VerticalAnchorMenu() {
    _classCallCheck(this, VerticalAnchorMenu);

    console.debug('VerticalAnchorMenu : Construct');

    if (!$('body').hasClass('hasVerticalAnchorMenu')) {
      return;
    }

    this.init();
  }
  /**
   *
   */


  _createClass(VerticalAnchorMenu, [{
    key: "init",
    value: function init() {
      console.debug('VerticalAnchorMenu : init');
      this.$container = $('.sideCol');

      if (this.$container.length === 0) {
        console.error('VerticalAnchorMenu activée, mais sans le gabarit de side bar (.sideCol)');
        return;
      }

      this.getSections();
      this.build();
    }
    /**
     * Recupère les section en fonction du markup js
     */

  }, {
    key: "getSections",
    value: function getSections() {
      this.sections = [];

      var _self = this;

      $('.mainCol h2').each(function (elt) {
        _self.sections.push({
          'title': $(this).html(),
          'elt': $(this)
        });
      });
    }
  }, {
    key: "build",
    value: function build() {
      var _this = this;

      if (this.sections) {
        this.$menu = $('<div>', {
          "class": 'verticalAnchorMenu'
        });
        this.$container.prepend(this.$menu);
        this.sections.forEach(function (section) {
          var item = $('<a>', {
            "class": "verticalAnchorMenu__item",
            href: section.link,
            html: $('<span>', {
              text: section.title
            })
          });
          $(item).on('click', function (event) {
            $(this).addClass('active').siblings().removeClass('active');
            event.preventDefault();
            $('html, body').stop().animate({
              scrollTop: section.elt.offset().top - 120
            }, 1000);
          });

          _this.$menu.append(item);
        }); // on calcule l'offset

        var offset = $('footer').offset().top;
        console.debug('offset', offset);

        if ($('.footerTopContent').length) {
          offset = $('.footerTopContent').offset().top;
          console.debug('offset', offset);
        }

        var mainColInfos = verge.rectangle('.mainCol');
        this.$menu.scrollToFixed({
          spacerClass: 'spacerClass',
          marginTop: 150,
          limit: verge.rectangle($('.mainCol')).bottom - this.$menu.outerHeight() - 150,
          removeOffsets: true
        });
      }
    }
  }]);

  return VerticalAnchorMenu;
}();

module.exports = VerticalAnchorMenu;

},{}],11:[function(require,module,exports){
"use strict";

var OnePageModeMenu = require('./modules/onePageModeMenu');

var VerticalAnchorMenu = require('./modules/verticalAnchorMenu');

var Anchors = require('./modules/anchors');

var ScrollAnimations = require('./modules/scrollAnimations');

var HeaderProducts = require('./modules/headerProducts');

var ContactFormOverlay = require('./modules/contactFormOverlay');

var Debug = require('./modules/debug');

var Keyfigure = require('./modules/keyFigure');

var ImgCopyright = require('./modules/imgCopyright');

var Accessibility = require('./modules/accessibility'); //const FactoringForm = require('./modules/factoringForm');


if ($('.subHeader').is(':visible')) {
  var subHeaderHeight = $('.subHeader').height();
} else {
  subHeaderHeight = 0;
}

function isFrench() {
  return $('html').attr('lang').includes('fr');
} // Récupération du code belink pour la gestion du zoom


var zoomActuel = 0;

function initZoomBtn() {
  $('.btnZoom__large').click(function () {
    if (zoomActuel == 0) {
      $('body').addClass('zoom_level_1');
      zoomActuel++;
    } else if (zoomActuel == 1) {
      $('body').removeClass('zoom_level_1').addClass('zoom_level_2');
      zoomActuel++;
    } else if (zoomActuel == 2) {
      $('body').removeClass('zoom_level_2').addClass('zoom_level_3');
      zoomActuel++;
    }
  });
  $('.btnZoom__small').click(function () {
    if (zoomActuel == 1) {
      $('body').removeClass('zoom_level_1');
      zoomActuel--;
    } else if (zoomActuel == 2) {
      $('body').removeClass('zoom_level_2').addClass('zoom_level_1');
      zoomActuel--;
    } else if (zoomActuel == 3) {
      $('body').removeClass('zoom_level_3').addClass('zoom_level_2');
      zoomActuel--;
    }
  });
  $('.btnZoom__normal').click(function () {
    if (zoomActuel == 1) {
      $('body').removeClass('zoom_level_1');
    } else if (zoomActuel == 2) {
      $('body').removeClass('zoom_level_2');
    } else if (zoomActuel == 3) {
      $('body').removeClass('zoom_level_3');
    }

    zoomActuel = 0;
  });
  $('.btnZoom__small, .btnZoom__large, .btnZoom__normal').on('focus', function () {
    $('#sb-search').removeClass('sb-search-open');
  });
}

function initH1() {
  $('.fixedheader').css('top', subHeaderHeight - $('.fixedheader').height());

  if ($('.mainTitle').length) {
    var title = $('.mainTitle').html();

    if (title.length > 53) {
      title = title.substring(0, 53) + '...';
    }

    $('.fixedheader .container .fakeh1').html(title);
  }
}

function fixH1() {
  $('.fixedheader').css('top', subHeaderHeight);
  $('.fixedheader').addClass('active');
}

function unfixH1() {
  $('.fixedheader').css('top', subHeaderHeight - $('.fixedheader').height());
  $('.fixedheader').removeClass('active');
}

function initResponsiveElement() {
  if ($(document).width() < 768) {
    $('body').addClass('mobile');
  }

  if ($(document).width() >= 768 && $(document).width() < 992) {
    $('body').addClass('tabletV');
  }

  var TL_burger = new TimelineMax();
  TL_burger.to('.subHeader', 1, {
    autoAlpha: 1,
    display: 'block'
  });
  TL_burger.pause();
  $('.menuBurger a').on('click', function () {
    $('body').removeClass('navOpen');
  });
  $('.bt-menu-trigger').find('.accessi').html(GBIS.lang == 'en' ? 'Open menu' : 'Ouvrir le menu');
  $('.bt-menu-trigger').click(function () {
    if ($(this).attr('aria-expanded') == 'false') {
      $(this).attr('aria-expanded', 'true');
      $(this).find('.accessi').html(GBIS.lang == 'en' ? 'Close menu' : 'Fermer le menu');
    } else {
      $(this).attr('aria-expanded', 'false');
      $(this).find('.accessi').html(GBIS.lang == 'en' ? 'Open menu' : 'Ouvrir le menu');
    }

    $(this).toggleClass('is-active');
    $('body').toggleClass('navOpen noscroll');

    if (gbis.isHamburgermenu && gbis.isTransparentHeader) {
      if ($('body').hasClass('navOpen')) {
        $('body').addClass('logoWhite');
      } else {
        if (!gbis.initLogoWhite) {
          $('body').removeClass('logoWhite');
        }
      }
    }
  }); // un peu d'accessibité avec les liens évitement

  if (gbis.isHamburgermenu) {
    $('#menu_accessible--menu').on('click', function (e) {
      e.preventDefault();
      $('.bt-menu-trigger').trigger('click');
      $('.menuBurger a').eq(0).focus();
      return false;
    });
    $('#menu_accessible--search').on('click', function (e) {
      e.preventDefault();
      $('.bt-menu-trigger').trigger('click');
      $('#form-search input[type="search"]').focus();
      return false;
    });
  } else {
    $('#menu_accessible--menu').on('click', function (e) {
      e.preventDefault();
      $('.topHeader .firstMenu .active a').eq(0).focus();
      return false;
    });
    $('#menu_accessible--search').on('click', function (e) {
      e.preventDefault();
      $('.sb-search').trigger('click');
      $('#form-search input[type="search"]').focus();
      return false;
    });
  }

  if (!$('body').hasClass('hamburgermenu')) {
    if (gbis.isHeaderOneLine) {
      var menuMarkup = $('.mainHeader--menu').html();
    } else {
      var menuMarkup = $('.subHeader nav').html();
    }

    $('.navmobileMenu').html(menuMarkup);
    $('.navmobileSearch').html($('header .sb-search').html());
    $('.navmobileTopMenu').html($('.topHeader .firstMenuWrap').html());
    $('#super_header--mobile').prependTo('#navmobile');
    $('#super_header--mobile').on('change', function () {
      window.location.href = $(this).val();
    });
    var attToChange = ['name', 'id', 'for'];
    $('.navmobileSearch #tx_indexedsearch, .navmobileSearch #tx_indexedsearch label, .navmobileSearch #tx_indexedsearch #searchForm').each(function () {
      for (var i = 0; i < attToChange.length; i++) {
        if ($(this).attr(attToChange[i]) == undefined || $(this).attr('id') == 'searchForm' && attToChange[i] == 'name') continue;
        var attr = $(this).attr(attToChange[i]);
        $(this).attr(attToChange[i], attr + '_mob');
      }
    });
    $('.navmobile .sb-icon-search').click(function () {
      $('#tx_indexedsearch_mob').submit();
    });

    if ($('.pickListHeader').children().length) {
      $('.navmobile').append($('.pickListHeader').clone());
      $('.navmobile .pickListHeader').removeClass('hidden-xs hidden-sm');
    }

    if ($('.langList').children().length) {
      $('.navmobileLang').html('<div class="navmobileLangSelect">' + $('.navmobileLang').data('label') + ' : <ul></ul></div>');
      $('.langList li').each(function () {
        $('.navmobileLangSelect ul').append($(this).clone());
      });
    }
  }

  if (gbis.is2015) {
    if ($('.clientBtn').children().length && isMobile()) {
      $('.clientAccessHeader').html('<div class="clientAccessHeaderSub row"><div class="col-xs-5 baseline">' + $('.mobileBaseline').html() + '</div><div class="col-xs-7 mobileClientBtnWrap">' + $('.clientBtn').html() + '</div></div>');
    }

    ;
  }

  if (!isMobile()) {
    $('.bioList__mini, .signatureList').each(function () {
      if ($(this).parents('.videoSingle_authors').length === 0) {
        var $c = $(this).find('.signatureContent');
        var $left, $right;
        $c.each(function (elt) {
          if ((elt + 1) % 2 == 0 && elt > 0) {
            $left = $c.eq(elt - 1);
            $right = $(this);
            var newHeight = Math.max($left.outerHeight(), $right.outerHeight());
            $left.css('height', newHeight);
            $right.css('height', newHeight);
          }
        });
      }
    });
  }
}

function initAutoSlideContents() {
  if ($(".ongletV").length) {
    $('.aside').prepend('<ul role="menu" class="sideMenu" id="addedSideMenu">');
    $(".ongletV .mainCol .ttcContent").wrapAll('<div class="owl-carousel" id="mainContentCarousel">');
    $(".ongletV .mainCol .ttcContent").each(function (elt) {
      if ($(this).hasClass("hideInPageDisposition1")) {
        if (elt == 0) {
          $("#mainContentCarousel").before($(this));
        } else {
          $("#mainContentCarousel").after($(this));
        }
      } else {
        $('#addedSideMenu').append('<li role="menuitem"><a href="#">' + $(this).find('h2').html() + '</a></li>');
      }
    });
    var mainContentCarousel = $('#mainContentCarousel').owlCarousel({
      autoPlay: false,
      stopOnHover: true,
      navigation: false,
      paginatio: false,
      goToFirstSpeed: 2000,
      singleItem: true,
      autoHeight: true,
      // on va ajuster aussi le menu de droite (afficher lelement actif) si on clique sur la pagination
      afterMove: function afterMove(elt, b) {
        $('.owl-pagination .owl-page').each(function (elt) {
          if ($(this).hasClass('active')) {
            $('#addedSideMenu li').eq(elt).addClass('active');
          } else {
            $('#addedSideMenu li').eq(elt).removeClass('active');
          }
        });
      }
    }).data('owlCarousel');
    $('#addedSideMenu li:first-child').addClass('active');
    $('#addedSideMenu li a').each(function (elt) {
      $(this).click(function () {
        mainContentCarousel.goTo(elt);
        $('#addedSideMenu li').removeClass('active');
        $(this).parent('li').addClass('active');
        return false;
      });
    });
  }
}

function adjustClientBtn() {
  var minWidth = $('#clientBtnDropDown').width();

  if ($('#client_access_menu').width() < minWidth - 20) {
    $('#client_access_menu').css('width', minWidth);
  }
}

var sgScrollManager = function () {
  function __checkSharerPb2019Color() {
    $('.shareBtn__row__btn').each(function () {
      var inCollision = $(this).collidesWith($('.ttcContent--dark'));

      if (inCollision.length) {
        $(this).addClass('onDarkBg');
      } else {
        $(this).removeClass('onDarkBg');
      }
    });
  }

  function init() {
    var _$$height;

    var _self = this;

    var headerHeight = ((_$$height = $('.contentHeader').height()) !== null && _$$height !== void 0 ? _$$height : 0) - 250;
    var $sharerPb2019 = $('.shareBtn--pb2019');

    if ($('.homePageCarrousel').length > 0) {
      headerHeight = 300;
    }

    if (headerHeight < 100) headerHeight = 50;
    window.addEventListener('scroll', function (e) {
      //if(!isMobile()) return;
      // Ajout de la gestion de la couleur de shareBtn--pb2019
      if ($sharerPb2019) {
        __checkSharerPb2019Color();
      }

      if ($(document).scrollTop() > 200) {
        $('body').addClass('isScrolled');
      } else {
        $('body').removeClass('isScrolled');
      }

      if ($(document).scrollTop() > headerHeight) {
        $('body').addClass('transparentHeader--scrolled');

        if (gbis.initLogoWhite) {
          $('body').removeClass('logoWhite');
        }
      } else {
        $('body').removeClass('transparentHeader--scrolled');

        if (gbis.initLogoWhite) {
          $('body').addClass('logoWhite');
        }
      }
    });
  }

  return {
    init: init
  };
}();

function initPowerMail() {
  $('.tx_powermail_pi1_form input:checkbox').click(function () {
    $(this).parent().parent().find('input:checkbox').blur();
    var checkid = $(this).attr('id');
    var valueid = checkid.replace(/check_/, 'value_');
    var targetid = checkid.replace(/check_/, '');
    $('#' + targetid).val($(this).is(':checked') ? $('#' + valueid).val() : '');
  });
}

$(document).ready(function () {
  initH1();
  initResponsiveElement();
  initAutoSlideContents();
  pistilMainMenu.init();
  adjustClientBtn();
  initTracking();
  initZoomBtn();
  $('.overflow--left, .overflow--right').contentOverflow();
  var onePageModeMenu = new OnePageModeMenu();
  var verticalAnchorMenu = new VerticalAnchorMenu();
  var anchors = new Anchors();
  var scrollAnimations = new ScrollAnimations();
  var headerProducts = new HeaderProducts();
  var contactFormOverlay = new ContactFormOverlay();
  var debug = new Debug();
  var keyfigure = new Keyfigure();
  var imgCopyright = new ImgCopyright();
  var accessibility = new Accessibility(); // gestion des evenements analytics

  initAddthisGaEvents('.addthis_toolbox a');
  initCardsGaEvents();
  initVideoGaEvents();
  initDceGaEvents();
  initImportFundsGaEvents();
  initContentsAssets();
  initPowerMail();
  $('.dce-verticalTabs').SGVerticalTabs(); // gestion de la movin line

  if (!gbis.isNvbq) {
    $('h1, .movingLineV2').SGMovingLine();
  }

  $('.resetDisclaimer a, .resetDisclaimer').click(function (e) {
    e.stopPropagation();
    $.cookie('disclaimer', null, {
      path: '/'
    });
    $.cookie('disclaimerDatas', null, {
      path: '/'
    });
    launchDisclaimer();
    return false;
  });

  if (gbis.isTransparentHeaderImmersive) {
    $('.headerImage').headerImmersive();
  }

  sgScrollManager.init();
  $('.sgnews_single_content .addeventatc').on('click', function () {
    gaTrackEvent({
      hitType: 'event',
      eventCategory: 'Calendar',
      eventAction: 'click',
      eventLabel: 'Add to Calendar News'
    });
  });
  $('.tx-dce-pi1 .addeventatc').on('click', function () {
    gaTrackEvent({
      hitType: 'event',
      eventCategory: 'Calendar',
      eventAction: 'click',
      eventLabel: 'Add to Calendar DCE'
    });
  });
  new cbpScroller(document.getElementsByTagName("body")[0]);

  if (!$('body').hasClass('hamburgermenu')) {
    new UISearch(document.getElementById('sb-search'));
  } // on fixe le header si mobile ou si burger menu, mais pas pour le mode isOnePageMenu ou isHeaderOneLine


  if ((isMobile() || gbis.isHamburgermenu) && !gbis.isOnePageMenu && !gbis.isHeaderOneLine) {
    $('header.mainHeader').scrollToFixed({
      spacerClass: 'mainHeaderSpacerClass',
      marginTop: 0
    });
  }

  if (!gbis.isHamburgermenu && !isMobile() && !isTabletV() && haveCss() && !gbis.isOnePageMenu) {
    $('.subHeader').scrollToFixed({
      spacerClass: 'spacerClass',
      fixed: function fixed() {
        if (!haveCss()) {
          $('.subHeader').attr('style', '');
        }

        ;
      }
    });
    $('main h1').not('.accessi').scrollToFixed({
      marginTop: -$('main h1').height(),
      unfixed: function unfixed() {
        unfixH1();
      },
      fixed: function fixed() {
        fixH1();
      }
    });
  }

  function needToFixAside() {
    return $(window).height() - $('.aside').outerHeight() - 135 > 0;
  }

  if ($('.aside').length && gbis.enabledFixedSideBar) {
    if (needToFixAside()) {
      $('.aside').scrollToFixed({
        marginTop: 135,
        removeOffsets: true,
        zIndex: 70,
        limit: $('.contentFooter').offset().top - $('.aside').outerHeight() - 50
      });
    }

    window.addEventListener("resize", function () {
      if (!needToFixAside()) {
        $('.aside').trigger('detach.ScrollToFixed');
      }
    });
  }

  if ($('.asideFromPlugin').length && gbis.is2018 && gbis.enabledFixedSideBar) {
    var limit = $('.contentFooter').offset().top;

    if ($('.ttcContent_fullwidth').length) {
      limit = $('.ttcContent_fullwidth').eq(0).offset().top;
    }

    $('.asideFromPlugin').scrollToFixed({
      marginTop: 50,
      removeOffsets: true,
      zIndex: 70,
      //limit:  limit - $('.asideFromPlugin').outerHeight() - 50 ,
      preFixed: function preFixed() {
        $('.asideFromPlugin').parent('div').addClass('empty');
        TweenMax.to('.asideFromPlugin', 0.5, {
          alpha: 0,
          onComplete: function onComplete() {
            $('.asideFromPlugin').addClass('corner');
            TweenMax.fromTo('.asideFromPlugin', 0.5, {
              alpha: 0,
              xPercent: 100
            }, {
              ease: Expo.easeOut,
              alpha: 1,
              delay: 0.5,
              xPercent: 0
            });
          }
        });
      },
      preUnfixed: function preUnfixed() {
        $('.asideFromPlugin').parent('div').removeClass('empty');
        $('.asideFromPlugin').removeClass('corner');
      }
    });
  }

  $('.langList a').focusin(function () {
    $(this).parents('.langList').addClass('open');
  });
  $('.langList li:last-child a').focusout(function () {
    $(this).parents('.langList').removeClass('open');
  });
  $('.langList').mouseover(function () {
    $(this).addClass('open');
  });
  $('.langList').mouseleave(function () {
    $(this).removeClass('open');
  });
  $('.customSelect').easyDropDown({
    cutOff: 10,
    wrapperClass: 'myDropDown'
  });
  $('.archives-toggle-wrapper .archives-toggle-btn').click(function () {
    $(this).next().parent().toggleClass('on');
    $(this).next().slideToggle('fast');
  });
  $('.topLink').click(function () {
    $('html, body').animate({
      scrollTop: 0
    }, 800); // on change le focus, et on le passe au log

    $('.mainLogo a').focus();
    return false;
  });
  eModal.setEModalOptions({
    fixedHeader: true,
    loadingHtml: '<span class="fa fa-circle-o-notch fa-spin fa-3x text-primary"></span><span class="h4">Loading</span>'
  });
  /*
  $('.zenPlay').click(function(){
      ga('send', 'event', 'button', 'click', 'lecture zen');
      if( typeof gaT2 != undefined) {ga('t2.send', 'event', 'button', 'click', 'lecture zen');}
      eModal.ajax({
          url: document.location.pathname + ' main',
          title: '&nbsp;',
          size: 'lg',
          buttons: []
      });
  });
  */

  if ($('.noboxed .tx-biimgcarrousel-pi1').length > 0) {
    $('.noboxed .tx-biimgcarrousel-pi1 .carrouselCard').addClass('noboxedSlider');
    $('.noboxed .tx-biimgcarrousel-pi1').parents('.mainCol').find('.ttcContent:nth-child(2)').addClass('afterSlider');
  }

  $('.tx-bisgsummary-pi3').cardWall();
  $('.tx-dce-pi1').cardWall();
  $('.wallCard').cardWall();
  $('.bioListItems').cardWall({
    'cardItem': '.vcard',
    'addSpinnerOnCard': false
  });
  $('.isotopeContainer').cardWall({
    'cardItem': '.card',
    'addSpinnerOnCard': false
  });
  $('.bioIsotope').cardWall({
    'cardItem': '.bioIsotope__item',
    'addSpinnerOnCard': false
  });
  $('.bioSidebarSlider').cardWall({
    'cardItem': '.bioSidebarSlider__item',
    'addSpinnerOnCard': false
  });
  $('.wallCard--slider').cardWall({
    'cardItem': '.card'
  });
  $('.pictoCard').click(function () {
    if ($(this).data('href') != undefined && $(this).data('href').charAt(0) != '/') {
      document.location.href = '/' + $(this).data('href');
    }
  });
  $('.tx-bilinksblock-pi1 li:last-child').addClass('last'); // dropdow dans le header

  $('.pickListHeader').on('mouseenter', function () {
    $(this).addClass('opened');
  }).on('mouseleave', function () {
    $(this).removeClass('opened');
  });
  $('.pickListHeader > a').on('focus', function () {
    $(this).parent().addClass('opened');
  });
  $('.pickListHeader li:last-child a').on('blur', function () {
    $(this).parents('.pickListHeader').removeClass('opened');
  }); // Gestion de l'ouverture du contenu de type popin

  if ($('#popinContent .popinContentWrap').children().length) {
    $.cookie.json = true;
    var validatedPopin = $.cookie('validatedPopin') != undefined ? $.cookie('validatedPopin') : [];
    var isAllReadyValidated = false;

    for (var i = 0; i < validatedPopin.length; i++) {
      if (validatedPopin[i] == $('.popinContentWrap').find('.ttcContent > div').attr('id')) {
        isAllReadyValidated = true;
      }
    }

    if (!isAllReadyValidated) {
      $('body').addClass('modalIn');
      $.magnificPopup.open({
        closeOnBgClick: false,
        items: {
          src: $('#popinContent .popinContentWrap'),
          // can be a HTML string, jQuery object, or CSS selector
          type: 'inline'
        }
      });
      $('.popinContentWrap #closePopin').click(function () {
        $('body').removeClass('modalIn');
        validatedPopin.push($(this).parents('.popinContentWrap').find('.ttcContent > div').attr('id'));
        $.cookie('validatedPopin', validatedPopin, {
          expires: 365,
          path: '/'
        });
        $.magnificPopup.close();
      });
    }
  } // rechargement de la frame


  if ($('#clientCoFrame').length) {
    setInterval(function () {
      $('#clientCoFrame').attr('src', $('#clientCoFrame').attr('src'));
    }, 600000);
  }

  $('.addthis_button_print').on('click', function () {
    window.print();
    return false;
  }); ///////////////////////////
  // Accessibility
  ///////////////////////////

  $(document).on('keydown', function (event) {
    if (event.which == 13) {
      if ($(':focus').hasClass('card') || $(':focus').hasClass('vcard')) {
        event.preventDefault();
        $(':focus').trigger('click');
      }

      if ($(':focus').hasClass('owl-page')) {
        $(':focus').trigger('mouseup');
      }
    }
  });
  $('.tx-powermail-pi1_formwrap input, .tx-powermail-pi1_formwrap select, .tx-powermail-pi1_formwrap textarea').each(function () {
    if ($(this).attr('tabindex')) {
      $(this).attr('tabindex', 0);
    }
  });
  var coockieBtnState = false;
  $('#cccwr #ccc-icon button').click(function () {
    if (!coockieBtnState) {
      coockieBtnState = true;
      $(this).find('img').attr('alt', $(this).find('img').data('openedlabel'));
    } else {
      coockieBtnState = false;
      $(this).find('img').attr('alt', $(this).find('img').data('closedlabel'));
    }
  });
  var gcseInt = setInterval(function () {
    if ($('.gsc-resultsbox-visible').length) {
      $('.gsc-control-cse img').each(function () {
        if (!$(this).attr('alt')) {
          $(this).attr('alt', '');
        }
      });
      $('.gsc-control-cse iframe').each(function () {
        if (!$(this).attr('title')) {
          $(this).attr('title', 'Google search iframe');
        }
      });
      clearInterval(gcseInt);
    }
  }, 200); // gestion du carrousel des

  $('.wallCard--webinarsAndParoles-slider .wallInsights').owlCarousel({
    loop: true,
    margin: 22,
    navigation: true,
    items: 3,
    itemsMobile: [670, 1],
    itemsDesktop: [1199, 3],
    itemsDesktopSmall: [992, 2]
  }); // autoexpends form

  $('textarea').on('keydown', function (evt) {
    var $elt = $(this);
    setTimeout(function () {
      $elt.css('height', 'auto');
      $elt.css('height', $elt.get(0).scrollHeight + 1 + 'px');
    }, 0);
  });
  $('.powermail_form').each(function () {
    var $form = $(this);
    var $submit = $(this).find('.powermail_submit');
    var formValidation = $(this).get(0).powermailFormValidation; // on évite le spam sur le formulaire

    formValidation.addSubmitErrorCallback('dontSpamValidation', function () {
      $form.removeClass('--submited');
    });
    $submit.on('click', function (e) {
      $form.addClass('--submited');
    });
  }); // ajouter des tables responsives, en wrappant tous la table dans un div.table-responsive

  $('.frame-type-text table, .ce-bodytext table').each(function () {
    $(this).wrap('<div class="table-responsive"></div>');
    $(this).addClass('table');
  });
});

},{"./modules/accessibility":1,"./modules/anchors":2,"./modules/contactFormOverlay":3,"./modules/debug":4,"./modules/headerProducts":5,"./modules/imgCopyright":6,"./modules/keyFigure":7,"./modules/onePageModeMenu":8,"./modules/scrollAnimations":9,"./modules/verticalAnchorMenu":10}]},{},[11]);
